import * as ActionTypes from './ActionTypes';

export const Autos = (state = {
        errMess: null,
        autos: []
    }, action) => {
    switch(action.type) {
        case ActionTypes.ADD_AUTOS:
            return {...state, isLoading: false, errMess: null, autos: action.payload};

        case ActionTypes.AUTOS_FAILED:
            return {...state, isLoading: false, errMess: action.payload, autos: []};

        case ActionTypes.ADD_AUTO:
            var auto = action.payload;
            return {...state, autos: state.autos.concat(auto)};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/autos.js